import React from 'react'

import Slider from '../components/Slider'
import NavBar from '../components/NavBar'
import Servicios from '../components/Servicios'
import Portafolio from '../components/Portafolio'
import SectionDivider from '../components/SectionDivider'

import '../css/Home.css'

const Home = () => {
    return (
        <main className='home-container'>

            <NavBar />

            {/* HERO */}
            <section className='hero-wrapper'>
                <Slider />

                <div className='hero-gradient'></div>

                <div className='divider-floating'>
                    <SectionDivider />
                </div>
            </section>

            {/* SERVICIOS */}
            <section className='services-wrapper'>
                <div className='bg-blur blur-left'></div>
                <div className='bg-blur blur-right'></div>

                <Servicios />

                <div className='divider-middle'>
                    <SectionDivider dark />
                </div>
            </section>

            {/* PORTAFOLIO */}
            <section className='portfolio-wrapper'>
                <div className='grid-bg'></div>

                <Portafolio />

                <div className='divider-dark'>
                    <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 1440 320'
                        preserveAspectRatio='none'
                    >
                        <path
                            fill='#0f172a'
                            fillOpacity='1'
                            d='M0,64L80,80C160,96,320,128,480,149.3C640,171,800,181,960,165.3C1120,149,1280,107,1360,85.3L1440,64L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z'
                        ></path>
                    </svg>
                </div>
            </section>

        </main>
    )
}

export default Home